export default __webpack_public_path__ + "static/media/coyote.9c9b6d72.webp";